function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '../Fetcher';
import { request } from '../request';
const claimGroupRolesService = {
  emailRoles: {
    'cost': 'claim_group_subscriber_cost_email',
    'ics_event_template': 'claim_group_subscriber_ics_email',
    'kickoff': 'claim_group_subscriber_kickoff_email'
  },
  async toggleConsultantExcludeFromEmail(claimGroupId, consultantId, isExcluded, emailType) {
    if (isExcluded) {
      return await claimGroupRolesService.delete(claimGroupId, consultantId, claimGroupRolesService.emailRoles[emailType]);
    } else {
      return await claimGroupRolesService.create(claimGroupId, consultantId, claimGroupRolesService.emailRoles[emailType]);
    }
  },
  delete(claimGroupId, userId, roleName) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/roles/").concat(userId, "?role=").concat(roleName), request.delete);
  },
  create(claimGroupId, userId, role) {
    let notify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const notifyParam = notify ? '?notify=true' : '';
    return fetch("/api/claim_groups/".concat(claimGroupId, "/roles/").concat(notifyParam), _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        user: {
          id: userId,
          role: role
        }
      })
    }));
  }
};
export default claimGroupRolesService;